import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useImpersonation } from "@/contexts/ImpersonationContext";

/**
 * VIB-3032: eier den aktive brukeren en aktiv leadliste? Da får hen Leads selv om rollen
 * ikke har menynøkkelen (ansatte som cold caller i tillegg til rollen sin). Samme regel som
 * crm_owns_lead_list() i databasen. Leser for aktiv bruker, så impersonering viser det riktige.
 */
export function useOwnsLeadList(): boolean {
  const { activeUser } = useImpersonation();
  const { data } = useQuery({
    queryKey: ["lead-list-ownership", activeUser?.id],
    queryFn: async (): Promise<boolean> => {
      const { data: rows, error } = await supabase
        .from("lead_lists")
        .select("id")
        .eq("owner_id", activeUser!.id)
        .eq("is_active", true)
        .limit(1);
      if (error) throw error;
      return (rows ?? []).length > 0;
    },
    enabled: !!activeUser?.id,
    staleTime: 5 * 60 * 1000,
  });
  return data ?? false;
}

/** Menynøkler som også åpnes av å eie en leadliste. */
export const LEAD_OWNER_MENU_KEYS: readonly string[] = ["salgsmuligheter.leads"];

/** Rollens tilgang, utvidet med listeeierskap for Leads (VIB-3032). */
export function withLeadListOwnership(menuKey: string, roleAccess: boolean, ownsLeadList: boolean): boolean {
  return roleAccess || (ownsLeadList && LEAD_OWNER_MENU_KEYS.includes(menuKey));
}
